import React from "react";
import "../../../../../styles/ambassadorChallenge/topParticipants.scss";
import gold from "../../../../../assets/ambassador/gold.png";
import silver from "../../../../../assets/ambassador/silver.png";
import bronze from "../../../../../assets/ambassador/bronze.png";
import { useAmbassadorChallengeContext } from "../../../../../contexts/AmbassadorChallengeContext";

const TopParticipants: React.FC = () => {
  const { leaderboardResponse } = useAmbassadorChallengeContext();

  const getMedalEmoji = (type: number): string => {
    switch (type) {
      case 1:
        return gold;
      case 2:
        return silver;
      case 3:
        return bronze;
      default:
        return '';
    }
  };

  const { setView, leaderboardData } = useAmbassadorChallengeContext();

  const participants = leaderboardData && leaderboardData.length > 0 ? leaderboardData.filter(item => item.rank <= 3) : [];

  return (
    <div className="top-participants-card">
      <div className="tp-header">
        <h3>{leaderboardResponse && leaderboardResponse.message ==='No active challenge' ? 'No' : 'Top'} Participant{leaderboardResponse && leaderboardResponse.message ==='No active challenge' ? '' : 's'}</h3>
        <button className="view-btn" onClick={()=>setView('Wall Of Fame')}>
          View previous winners
          <span>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_11154_60196)">
                <path
                  d="M5 12H19"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M13 18L19 12"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M13 6L19 12"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_11154_60196">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </span>
        </button>
      </div>

      <div className="tp-list">
        {participants && participants.map((p) => (
          <div key={p.referrer_id} className="tp-item">
            <div className="tp-left">
              <div className={`tp-rank rank-${p.rank}`}>{p.rank}</div>
              <div className="tp-info">
                <h4>
                  {p.referrer_name}{" "}
                  <img
                    src={getMedalEmoji(p.rank)}
                    alt="medal"
                    className="medal"
                  />
                </h4>
                <p>{p.verified_referrals_count} Invites</p>
              </div>
            </div>

            <div className="tp-right">
              <p className="tp-time">Last: {p.last_referral_time}</p>

              {p.qualified && (
                <div className={`tp-status qualified`}>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.11 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
                      fill="#4A941C"
                    />
                  </svg>
                  Qualified
                </div>
              )}

              {!p.qualified && (
                <div className={`tp-status not-qualified`}>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                      fill="#FF3932"
                    />
                  </svg>
                  Not Qualified
                </div>
              )}

            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopParticipants;
